import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { SearchLocationCompanyIdBase } from '../../../components/SearchLocationCompanyIdBase';
import { applyKanbanFilters, resetKanbanFilter, updateKanbanFilter } from '../actions';

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(property) {
      dispatch(resetKanbanFilter(property))
    },
    applyFilters() {
      dispatch(applyKanbanFilters());
    },
    changeValues(key, value, label = '') {
      dispatch(
        updateKanbanFilter({
          key,
          value: [value],
          label: [label],
          type: 'single',
        }),
      );
    },

    change(value) {
      dispatch(
        updateKanbanFilter({
          value: [value.id],
          label: [value.name],
          key: 'location_company_id',
          type: 'single',
        }),
      );
      dispatch(applyKanbanFilters());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SearchLocationCompanyId = compose(withConnect, withRouter, injectIntl)(SearchLocationCompanyIdBase);
